import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, Subscriber } from 'rxjs';

import * as Models from 'appshared/shared-models';
import { DocumentsService } from './documents.service';

// this thing (a resolve) will run before a route is routed
// basically, grab the items from the service

@Injectable({ providedIn: 'root' })
export class DocumentsResolverService implements Resolve<Models.Document[]> {
	constructor(private objService: DocumentsService) { }

	resolve(): Observable<Models.Document[]> | Observable<never> | Models.Document[] {
		// check to see if the items have ever been loaded.  If not, load'em
		if (this.objService.loaded) {
			// console.log('in resolver - the list is alive!');
			return this.objService.getAll();
		} else {
			// console.log('in resolver - need a new list');
			return new Observable((observe: Subscriber<Models.Document[]>) => {
				this.objService.refreshAll().subscribe((items: Models.Document[]) => {
					observe.next(items);
					observe.complete();
				});
			});
		}
	}
}



